import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledVideoPlayer = styled.div`
  width: 100%;
  height: 100%;
  .fullscreen {
    width: 100%;
    height: 100%;
    .player-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      /* width: ${(props) => props.size.width}px;
      height: ${(props) => props.size.height}px;
      margin: 0 ${(props) => props.size.horizontalPadding}px; */
      border-radius: 5px;
      overflow: hidden;
      z-index: 1;

      .react-player {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
      }
      .video-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        * {
          pointer-events: auto;
        }
        .poster-image {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          z-index: 10;
          .poster {
            object-fit: contain;
          }
        }
        .big-play {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 20;
          background-color: ${Colors.darkBlue}55;
          display: flex;
          gap: 10px;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          &.invisible {
            opacity: 0;
          }
          .play-again {
            color: ${Colors.background}cc;
            font-size: 30px;
            font-weight: bold;
            cursor: pointer;
          }
          .play-icon {
            font-size: 100px;
            color: ${Colors.background}aa;
            cursor: pointer;
          }
        }
      }
    }
  }
  .fullscreen.fullscreen-enabled {
    .player-wrapper {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }
`;
